export const mergeSnapshotGridRows = <Row extends { id: string }>(existingRows: Row[], nextRows: Row[]): Row[] => {
  const rowsById = new Map(existingRows.map(row => [row.id, row]));

  for (const row of nextRows) {
    rowsById.set(row.id, row);
  }

  return Array.from(rowsById.values());
};

/** Swaps in fresh copies of rows already loaded; rows the grid has not loaded are ignored (they may be filtered out). */
export const replaceSnapshotGridRows = <Row extends { id: string }>(existingRows: Row[], freshRows: Row[]): Row[] => {
  const freshById = new Map(freshRows.map(row => [row.id, row]));
  if (!existingRows.some(row => freshById.has(row.id))) return existingRows;

  return existingRows.map(row => freshById.get(row.id) ?? row);
};

export const getHasNextSnapshotGridPage = ({ loadedCount, total }: { loadedCount: number; total: number }): boolean =>
  loadedCount < total;

export const isSnapshotGridNearEnd = ({
  scrollTop,
  scrollHeight,
  clientHeight,
  threshold,
}: {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
  threshold: number;
}): boolean => scrollHeight - scrollTop - clientHeight <= threshold;
